export var EXTERNAL_INELIGIBLE_STATUSES = ['pending', 'suspended'];
//# sourceMappingURL=external.js.map